var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.066,
    height: 44.066,
    viewBox: "0 0 44.066 44.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_gallery",
    "data-name": "vuesax/bold/gallery",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.973,3.635l-.037.037A11.36,11.36,0,0,1,0,0,11.278,11.278,0,0,0,.973,3.635Z",
    transform: "translate(3.764 31.268)",
    fill: "#0846a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.74,4.37A4.37,4.37,0,1,1,4.37,0,4.37,4.37,0,0,1,8.74,4.37Z",
    transform: "translate(12.155 10.319)",
    fill: "#0846a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M26.054,0H10.668C3.984,0,0,3.984,0,10.668V26.054a12.344,12.344,0,0,0,1.028,5.214c1.579,3.489,4.957,5.453,9.639,5.453H26.054c6.683,0,10.668-3.984,10.668-10.668V10.668C36.722,3.984,32.737,0,26.054,0Zm7.675,19.279a4.093,4.093,0,0,0-5.178,0l-7.638,6.555a4.093,4.093,0,0,1-5.178,0l-.624-.514a4.078,4.078,0,0,0-4.847-.257L3.4,29.671a9.792,9.792,0,0,1-.643-3.617V10.668c0-5.178,2.736-7.914,7.914-7.914H26.054c5.178,0,7.914,2.736,7.914,7.914v8.813Z",
    transform: "translate(3.672 3.672)",
    fill: "#0846a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H44.066V44.066H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard5);
export default __webpack_public_path__ + "static/media/dashboard5.b21db0fbe2f15433d63dca8a9818f020.svg";
export { ForwardRef as ReactComponent };